// extracted by mini-css-extract-plugin
export default {"addressInputWrapper":"AddressDelivery_addressInputWrapper__NwXL1"};